import {
  NavigationPanelGroupingOption,
  NavigationPanelGroupingOptionType,
} from '@/constants/NavigationPanelGroupingOption';
import { MAX_NUM_ITEMS_PINNABLE } from '@/constants/PortfolioViewGrouping';
import { PortfolioType } from '@/types/portfolio';
import type { PortfolioTreeGroupingDTO } from '@/types/portfolio/PortfolioTreeGroupingDTO';

function createCustomGrouping(property: NavigationPanelGroupingOption): PortfolioTreeGroupingDTO {
  return {
    type: NavigationPanelGroupingOptionType.CUSTOM,
    keys: [{ property }],
  };
}

/**
 * Type-specific VIEW grouping used when a portfolio exceeds {@link MAX_NUM_ITEMS_PINNABLE}.
 * Peer groups have no default; callers should keep the existing unpin-all path.
 */
export function getDefaultViewGroupingConfig({
  type,
  itemCount,
}: {
  type: PortfolioType;
  itemCount: number;
}): PortfolioTreeGroupingDTO | undefined {
  if (itemCount <= MAX_NUM_ITEMS_PINNABLE) return undefined;

  if (type === PortfolioType.PEER_GROUP) return undefined;

  if (type === PortfolioType.EQUITY_BASKET) {
    return createCustomGrouping(NavigationPanelGroupingOption.CONSTITUENT_SECTOR);
  }

  if (type === PortfolioType.QIS_BASKET) {
    return createCustomGrouping(NavigationPanelGroupingOption.STRATEGY_FACTOR);
  }

  // Portfolio, Benchmark (`isBenchmark`), and Constituent all group by Asset Class
  return createCustomGrouping(NavigationPanelGroupingOption.STRATEGY_ASSET_CLASS);
}
